import { Pipe, PipeTransform } from '@angular/core';
import { Content } from '@fgb/core';


@Pipe({
  name: 'currentLanguageContent',
})
/**
 * This pipe is used to get the content by lcid
 * it will take the list of content and lcid and return
 * the contact that match the lcid otherwise return the
 * firts one
 * Example of usage:
 * <p> {{  let content of offerContentList | currentLanguageContent: 2057}} </p>"
 */
export class ContentLanguageFilterPipe implements PipeTransform {
  transform(contents: Content[], lcid: string, callFor: string): string {
    callFor = callFor.toLowerCase();
    if (!contents) return 'n/a';
    if (!contents?.some((x) => x.LCID == +lcid)) {
      return callFor == 'name' ? contents[0].Name : callFor == 'description' ? contents[0].Description : 'n/a';
    }
    let langContent = contents?.filter((content) => {
      return content.LCID == +lcid;
    });

    if (langContent)
      return callFor == 'name' ? langContent[0].Name : callFor == 'description' ? langContent[0].Description : 'n/a';
    return 'n/a';
  }
}
